import {createSelector} from 'reselect';
import {getSelectedDeliveryCountry, getSettings} from './selectors';

export const isDeliveryCountryTaxable = createSelector(
  [getSelectedDeliveryCountry, getSettings],
  (selectedDeliveryCountry, settings) => (
    settings.delivery_countries_to_show_tax && settings.delivery_countries_to_show_tax
      .map(country => country.toUpperCase())
      .includes(selectedDeliveryCountry?.toUpperCase())
  ),
);
